import { Alignments } from './alignments';
export const ImagePopoverTabs = {
  CONTENT_TAB: 'CONTENT_TAB',
  STYLE_TAB: 'STYLE_TAB',
  LINK_TAB: 'LINK_TAB'
};
export const ImageAlignmentClasses = {
  [Alignments.CENTER]: 'hs-image-align-center',
  [Alignments.LEFT]: 'hs-image-align-left',
  [Alignments.RIGHT]: 'hs-image-align-right',
  [Alignments.NONE]: 'hs-image-align-none'
};